import * as Yup from "yup";

export const sharedFileValidationSchema = Yup.object().shape({
  instructions: Yup.string()
});
